export enum ModalTypes {
    UPLOAD_AVATAR = 'UPLOAD_AVATAR',
    MAP = 'MAP',
    EDITING_BEST_EMPLOYEES = 'EDITING_BEST_EMPLOYEES',
    EDITING_PERSONAL_DATA = 'EDITING_PERSONAL_DATA',
}
